import { createStore } from 'vuex'
import user from './modules/user'
import reports from './modules/reports'
import reclaimDashboard from './modules/reclaim-dashboard-serverside'
import reliefAtSource from './modules/relief-at-source'
import quarterlyStatements from './modules/quarterly-statement'
import paymentStatements from './modules/payment-statement'
import documentManagement from './modules/document-management'

const store = createStore({
  // Making sure that we're doing
  // everything correctly by enabling
  // strict mode in the dev environment.
  strict: !import.meta.env.PROD,
  state: {},
  modules: {
    user,
    reports,
    reclaimDashboard,
    reliefAtSource,
    quarterlyStatements,
    paymentStatements,
    documentManagement,
  },
  mutations: {},
  actions: {},
  getters: {},
  plugins: [],
})

export default store
